import { COLOR_BACKGROUND_CARD_LIGHT, COLOR_BACKGROUND_BACKDROP_STRONG_LIGHT, COLOR_BACKGROUND_LEVEL_0_LIGHT, COLOR_BACKGROUND_LEVEL_1_LIGHT, COLOR_BACKGROUND_LEVEL_2_LIGHT, COLOR_BACKGROUND_LEVEL_3_LIGHT, COLOR_BASE_BRAND_BLACK, COLOR_BASE_BRAND_PROGRESSIVE_RED, COLOR_BASE_BRAND_WHITE, COLOR_BASE_CHARGING_NEON_BLUE_LIGHT, COLOR_BASE_GREY_0, COLOR_BASE_GREY_10, COLOR_BASE_GREY_100, COLOR_BASE_GREY_15, COLOR_BASE_GREY_20, COLOR_BASE_GREY_30, COLOR_BASE_GREY_40, COLOR_BASE_GREY_5, COLOR_BASE_GREY_50, COLOR_BASE_GREY_60, COLOR_BASE_GREY_70, COLOR_BASE_GREY_80, COLOR_BASE_GREY_90, COLOR_BASE_SIGNAL_GREEN_LIGHT, COLOR_BASE_SIGNAL_RED_LIGHT, COLOR_BASE_SIGNAL_YELLOW_LIGHT, COLOR_CHARGING_DEFAULT_LIGHT, COLOR_CHARGING_INTELLIGENT_LIGHT, COLOR_INTERACTION_LABEL_ACTIVE_LIGHT, COLOR_INTERACTION_LABEL_DEFAULT_LIGHT, COLOR_INTERACTION_LABEL_DISABLED_LIGHT, COLOR_INTERACTION_LABEL_FILLED_LIGHT, COLOR_INTERACTION_LABEL_FOCUS_LIGHT, COLOR_INTERACTION_LABEL_HOVER_LIGHT, COLOR_INTERACTION_LABEL_PRESSED_LIGHT, COLOR_INTERACTION_LABEL_READONLY_LIGHT, COLOR_INTERACTION_PRIMARY_ACTIVE_LIGHT, COLOR_INTERACTION_PRIMARY_DEFAULT_LIGHT, COLOR_INTERACTION_PRIMARY_DISABLED_LIGHT, COLOR_INTERACTION_PRIMARY_FOCUS_LIGHT, COLOR_INTERACTION_PRIMARY_HOVER_LIGHT, COLOR_INTERACTION_PRIMARY_PRESSED_LIGHT, COLOR_INTERACTION_SECONDARY_ACTIVE_LIGHT, COLOR_INTERACTION_SECONDARY_DEFAULT_LIGHT, COLOR_INTERACTION_SECONDARY_DISABLED_LIGHT, COLOR_INTERACTION_SECONDARY_FILLED_LIGHT, COLOR_INTERACTION_SECONDARY_FOCUS_LIGHT, COLOR_INTERACTION_SECONDARY_HOVER_LIGHT, COLOR_INTERACTION_SECONDARY_PRESSED_LIGHT, COLOR_INTERACTION_SECONDARY_READONLY_LIGHT, COLOR_INTERACTION_TERTIARY_ACTIVE_LIGHT, COLOR_INTERACTION_TERTIARY_DEFAULT_LIGHT, COLOR_INTERACTION_TERTIARY_DISABLED_LIGHT, COLOR_INTERACTION_TERTIARY_HOVER_LIGHT, COLOR_UI_DIVIDER_LIGHT, COLOR_UI_ERROR_LIGHT, COLOR_UI_HIGHLIGHT_PRIMARY_LIGHT, COLOR_UI_HIGHLIGHT_SECONDARY_LIGHT, COLOR_UI_HIGHLIGHT_TERTIARY_LIGHT, COLOR_UI_INVERTED_LIGHT, COLOR_UI_PENDING_LIGHT, COLOR_UI_PRIMARY_LIGHT, COLOR_UI_SECONDARY_LIGHT, COLOR_UI_SUCCESS_LIGHT, COLOR_UI_TERTIARY_LIGHT, } from "@audi/audi-ui-design-tokens";
export const colors = {
    base: {
        brand: {
            white: COLOR_BASE_BRAND_WHITE,
            black: COLOR_BASE_BRAND_BLACK,
            progressiveRed: COLOR_BASE_BRAND_PROGRESSIVE_RED,
        },
        grey: {
            0: COLOR_BASE_GREY_0,
            5: COLOR_BASE_GREY_5,
            10: COLOR_BASE_GREY_10,
            15: COLOR_BASE_GREY_15,
            20: COLOR_BASE_GREY_20,
            30: COLOR_BASE_GREY_30,
            40: COLOR_BASE_GREY_40,
            50: COLOR_BASE_GREY_50,
            60: COLOR_BASE_GREY_60,
            70: COLOR_BASE_GREY_70,
            80: COLOR_BASE_GREY_80,
            90: COLOR_BASE_GREY_90,
            100: COLOR_BASE_GREY_100,
        },
        signal: {
            green: COLOR_BASE_SIGNAL_GREEN_LIGHT,
            red: COLOR_BASE_SIGNAL_RED_LIGHT,
            yellow: COLOR_BASE_SIGNAL_YELLOW_LIGHT,
        },
        charging: {
            neonBlue: COLOR_BASE_CHARGING_NEON_BLUE_LIGHT,
            neonGreen: COLOR_BASE_CHARGING_NEON_BLUE_LIGHT,
        },
    },
    charging: {
        default: COLOR_CHARGING_DEFAULT_LIGHT,
        intelligent: COLOR_CHARGING_INTELLIGENT_LIGHT,
    },
    background: {
        level: {
            0: COLOR_BACKGROUND_LEVEL_0_LIGHT,
            1: COLOR_BACKGROUND_LEVEL_1_LIGHT,
            2: COLOR_BACKGROUND_LEVEL_2_LIGHT,
            3: COLOR_BACKGROUND_LEVEL_3_LIGHT,
        },
        card: COLOR_BACKGROUND_CARD_LIGHT,
        backdrop: {
            strong: COLOR_BACKGROUND_BACKDROP_STRONG_LIGHT,
        },
    },
    interaction: {
        primary: {
            default: COLOR_INTERACTION_PRIMARY_DEFAULT_LIGHT,
            hover: COLOR_INTERACTION_PRIMARY_HOVER_LIGHT,
            active: COLOR_INTERACTION_PRIMARY_ACTIVE_LIGHT,
            disabled: COLOR_INTERACTION_PRIMARY_DISABLED_LIGHT,
            focus: COLOR_INTERACTION_PRIMARY_FOCUS_LIGHT,
            pressed: COLOR_INTERACTION_PRIMARY_PRESSED_LIGHT,
        },
        secondary: {
            default: COLOR_INTERACTION_SECONDARY_DEFAULT_LIGHT,
            hover: COLOR_INTERACTION_SECONDARY_HOVER_LIGHT,
            active: COLOR_INTERACTION_SECONDARY_ACTIVE_LIGHT,
            filled: COLOR_INTERACTION_SECONDARY_FILLED_LIGHT,
            disabled: COLOR_INTERACTION_SECONDARY_DISABLED_LIGHT,
            focus: COLOR_INTERACTION_SECONDARY_FOCUS_LIGHT,
            readonly: COLOR_INTERACTION_SECONDARY_READONLY_LIGHT,
            pressed: COLOR_INTERACTION_SECONDARY_PRESSED_LIGHT,
        },
        tertiary: {
            default: COLOR_INTERACTION_TERTIARY_DEFAULT_LIGHT,
            hover: COLOR_INTERACTION_TERTIARY_HOVER_LIGHT,
            active: COLOR_INTERACTION_TERTIARY_ACTIVE_LIGHT,
            disabled: COLOR_INTERACTION_TERTIARY_DISABLED_LIGHT,
        },
        label: {
            default: COLOR_INTERACTION_LABEL_DEFAULT_LIGHT,
            hover: COLOR_INTERACTION_LABEL_HOVER_LIGHT,
            active: COLOR_INTERACTION_LABEL_ACTIVE_LIGHT,
            filled: COLOR_INTERACTION_LABEL_FILLED_LIGHT,
            disabled: COLOR_INTERACTION_LABEL_DISABLED_LIGHT,
            focus: COLOR_INTERACTION_LABEL_FOCUS_LIGHT,
            readonly: COLOR_INTERACTION_LABEL_READONLY_LIGHT,
            pressed: COLOR_INTERACTION_LABEL_PRESSED_LIGHT,
        },
    },
    ui: {
        primary: COLOR_UI_PRIMARY_LIGHT,
        secondary: COLOR_UI_SECONDARY_LIGHT,
        tertiary: COLOR_UI_TERTIARY_LIGHT,
        inverted: COLOR_UI_INVERTED_LIGHT,
        highlight: {
            primary: COLOR_UI_HIGHLIGHT_PRIMARY_LIGHT,
            secondary: COLOR_UI_HIGHLIGHT_SECONDARY_LIGHT,
            tertiary: COLOR_UI_HIGHLIGHT_TERTIARY_LIGHT,
        },
        divider: COLOR_UI_DIVIDER_LIGHT,
        error: COLOR_UI_ERROR_LIGHT,
        success: COLOR_UI_SUCCESS_LIGHT,
        pending: COLOR_UI_PENDING_LIGHT,
    },
};
//# sourceMappingURL=audi-colors.mjs.mjs.map